import { useRef, useState } from 'react'
import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faEnvelope, faMailBulk, faMailForward, faMailReply, faPhone, faSpellCheck } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import FrequencyVisualizer from './FrequencyVisualizer';
import Stefan from './Stefan';
import Enrico from './Enrico';
import CoachingDetailComp from './CoachingDetailComp';
import CoachingDetailComp2 from './CoachingDetailComp2';
import Locations from './Locations';
import Contact from './Contact';
import Footer from './Footer';
import Comment from './Comment';
import React, { Fragment, Suspense, useEffect } from 'react';
import Coachingoffer from './Coaching';

const navigation = [
  { name: 'Über uns', id: 'stefan' },
  { name: 'Angebot', id: 'coachingoffer' },
  { name: 'Kontakt', id: 'contact' },
]
function useDynamicRefs() {
  const refsMap = useRef({});
  const getRef = (id) => {
    if (!refsMap.current[id]) {
      refsMap.current[id] = React.createRef();
    }
    return refsMap.current[id];
  };
  return getRef;
}

export default function Landing() {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const getRef = useDynamicRefs();
  // Refs für jeden Autor-Abschnitt
  const navigateToSection = (id) => {
   const ref = getRef(id);
   if (ref.current) {
     ref.current.scrollIntoView({ behavior: 'smooth' });
   }
 };
 

  return (
    <>
    <div className="bg-white bg-cover bg-no-repeat bg-center" style={{ backgroundImage: "url('Flussschleife im Sonnenuntergang2.jpeg')", height: '900px'}}>
      <header className="absolute inset-x-0 top-0 z-50">
        <nav className="flex items-center justify-between p-3 lg:px-8" aria-label="Global">
          <div className="flex lg:flex-1">
            <a href="#" className="-m-1 p-1">
              <span className="sr-only">Your Company</span>
              <img
                className="h-20 w-auto"
                src="Logo-Frequenz741-dunkel.svg"
                alt=""
                
              />
            </a>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-300"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12">
            {navigation.map((item) => (
              <a key={item.name} onClick={() => navigateToSection(item.id)} className="cursor-pointer text-sm font-semibold leading-6 text-white" style={{ textShadow: "1px 1px 5px rgba(0, 0, 0, 1)" }}>
                {item.name}
              </a>
            ))}
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <a onClick={() => window.location.href='mailto:info@frequenz741.de'} className="px-2 text-sm font-semibold leading-6 text-gray-100" title='E-Mail an info@frequenz741.de schreiben'>
            <FontAwesomeIcon icon={faEnvelope} />
            </a>
            <a onClick={() => window.location.href='tel:+491723570148'} className="px-2 text-sm font-semibold leading-6 text-gray-100" title='Telefonnummer +49 172 3570148 anrufen'>
            <FontAwesomeIcon icon={faPhone} />
            </a>
          </div>
        </nav>
        <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 max-w-sm sm:ring-1 ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a onClick={(e)=>{navigate('/')}} className="-m-1.5 p-1.5">
                <span className="sr-only">Frequenz 741</span>
                <img
                  className="h-20 w-auto"
                  src="Logo-Frequenz741-hell.svg"
                  alt=""
                />
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <a
                      key={item.name}
                      onClick={() => navigateToSection(item.id)}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
                <div className="py-6">
                <a onClick={() => window.location.href='mailto:info@frequenz741.de'} className="px-2 text-sm font-semibold leading-6 text-gray-800" title='E-Mail an info@frequenz741.de schreiben'>
            <FontAwesomeIcon icon={faEnvelope} />
            </a>
            <a onClick={() => window.location.href='tel:+491723570148'} className="px-2 text-sm font-semibold leading-6 text-gray-800" title='Telefonnummer +49 172 3570148 anrufen'>
            <FontAwesomeIcon icon={faPhone} />
            </a>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>

      <div className="relative isolate px-6 pt-14 lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#bf0000ff] to-[#ff2828ff] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
        <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
          <div className="hidden sm:mb-8 sm:flex sm:justify-center">
            <div className="cursor-pointer relative rounded-full px-3 py-1 text-sm leading-6 text-gray-300 ring-1 ring-red-900 hover:ring-gray-900/20">
            Hier zu unseren Coaching-Angeboten {' '}
              <a onClick={() => navigateToSection('coach')} className="font-semibold text-red-600">
                <span className="absolute inset-0" aria-hidden="true" />
                Mehr erfahren <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl" style={{ textShadow: "1px 1px 5px rgba(0, 0, 0, 1), 2px 2px 10px rgba(0, 0, 0, 1), 3px 3px 15px rgba(0, 0, 0, 1),2px 2px 10px rgba(0, 0, 0, 1)" }}>
            Ihre Frequenz. Ihr Bewusstsein. Ihre Veränderung.
            </h1>
            <p className="mt-6 text-lg leading-8 text-white" style={{ textShadow: "1px 1px 5px rgba(0, 0, 0, 1), 2px 2px 10px rgba(0, 0, 0, 1), 3px 3px 15px rgba(0, 0, 0, 1),2px 2px 10px rgba(0, 0, 0, 1)" }}>
            Mit unserem Coaching entfesseln wir mit Ihnen das volle Potenzial Ihrer Mitarbeiter und steigern Ihre Attraktivität als Unternehmer.
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <a
                onClick={() => navigateToSection('contact')}
                className="rounded-md bg-red-800 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Jetzt Beratungstermin vereinbaren
              </a>
              <a onClick={() => navigateToSection('coachingoffer')} className="cursor-pointer text-sm font-semibold leading-6 text-gray-300">
                Mehr erfahren <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>
        
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#bf0000ff] to-[#ff2828ff] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
      </div>
    
    </div>
    <FrequencyVisualizer/>
 
              <Comment/>
              <div ref={getRef('coachingoffer')}></div>
              <Coachingoffer/>
              <div ref={getRef('coach')}></div>
              <CoachingDetailComp2/>
              <CoachingDetailComp/>
              <div ref={getRef('stefan')}></div>
              <Stefan />
              <Enrico/>
              <Locations/>
              <div ref={getRef('contact')}></div>
              <Contact />
              <Footer/>
    </>
  )
}
